// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const kingler_gmax: PokeData = {
  "id": 10203,
  "name": "kingler-gmax",
  "height": 190,
  "weight": 10000,
  "base_experience": 166,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [],
  "moves": [
    "whirlpool",
    "aqua-jet",
    "hydro-pump",
    "brine",
    "bubble-beam",
    "bubble",
    "aqua-tail",
    "life-dew",
    "aqua-cutter",
    "water-spout"
  ],
  "evolution_chain": {
    "id": 43,
    "item": null,
    "species": [
      {
        "name": "krabby",
        "order": 107,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "kingler",
        "order": 108,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 98,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 28,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 100,
    "speed": 110,
    "ability_power": 190
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": true,
  "regional_variant": null
} as const;
